export default "__VITE_ASSET__BjYPMZST__"